import {
  IndexPath,
  SignInCallbackPath,
  SignOutCallbackPath,
  SignOutPath
} from '../paths';

import AccountDeletionInstructions from '../../pages/Account/DeletionInstructions';
import { DOMAIN } from '../../consts';
import { IBreadcrumbRouteProps } from '../types';
import Index from '../../pages/index';
import NotFound from '../../pages/Error/NotFound';
import React from 'react';
import { Redirect } from 'react-router-dom';
import SignInCallback from '../../pages/SignInCallback';
import SignOut from '../../pages/SignOut';
import SignOutCallback from '../../pages/SignOutCallback';
import adminRoutes from './admin';
import userRoutes from './user';

const routes: IBreadcrumbRouteProps[] = [
  {
    children: () => <Index />,
    exact: true,
    path: IndexPath
  },

  ...(DOMAIN === 'admin' ? adminRoutes : []),
  ...(DOMAIN === 'user' ? userRoutes : []),

  {
    children: () => <SignInCallback />,
    path: SignInCallbackPath
  },
  {
    children: () => <SignOut />,
    path: SignOutPath
  },
  {
    children: () => <SignOutCallback />,
    path: SignOutCallbackPath
  },
  {
    children: () => <AccountDeletionInstructions />,
    path: '/account-deletion'
  },
  {
    breadcrumb: '404',
    children: () => <NotFound />,
    path: '/404'
  },
  {
    children: ({ location }) => (
      <Redirect to={{ pathname: '/404', state: { from: location } }} />
    ),
    path: '*'
  }
];

export default routes;
